import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[appTrim]'
})
export class TrimDirective {


    constructor(private el: ElementRef) { }

    @HostListener('blur', ['$event.target.value'])
    onBlur(value: string) {
        this.trimFirstChar(value);
    }

    @HostListener('input', ['$event.target.value'])
    onInput(value: string) {
        this.trimFirstChar(value);
    }

    private trimFirstChar(value: string) {
        let trimmedValue = value.replace(/^\s+/, ''); // Remove leading spaces only
        if (value !== trimmedValue) {
            this.el.nativeElement.value = trimmedValue;
            // To trigger Angular form validation and value updates
            this.el.nativeElement.dispatchEvent(new Event('input'));
        }
    }
}